"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWxPushBase = getWxPushBase;
exports.wxBindStatusBatch = wxBindStatusBatch;
exports.wxToggleReceive = wxToggleReceive;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var PUSH_BASE = 'https://youxiang-push-server.youxiangonline.com';
function wxBindStatusBatch(data) {
  return _axios.default.post("".concat(PUSH_BASE, "/wx/mp/bind/status/batch"), data).then(function (res) {
    return res.data;
  });
}
function wxToggleReceive(data) {
  return _axios.default.post("".concat(PUSH_BASE, "/wx/mp/bind/unbind"), data).then(function (res) {
    return res.data;
  });
}
function getWxPushBase() {
  return PUSH_BASE;
}